var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._g(_vm._b({attrs:{"outlined":"","dense":"","item-value":_vm.itemValue,"item-text":_vm.itemText}},'v-autocomplete',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }